export const openAddress = (address: string) => {
  return `https://yandex.ru/maps/?text=${address}`;
};
